import React from 'react';
import { resolveBrand } from '@/config/brand';

/**
 * 品牌模拟切换按钮（品牌配置 showBrandDebugSwitch = true 时展示）
 *
 * 依托 resolveBrand() 的 ?brand=xxx 调试覆盖机制（见 src/config/brand.ts），
 * 点击即在「当前品牌 ↔ 调试品牌」间切换并整页刷新，
 * 用于本地验证各品牌形态（logo、默认语种、菜单裁剪等）。
 *
 * 当前支持模拟：gxzs（aifilm.gxzs.top）、juxflow（juxflow.ame-film.com，默认英文）
 *
 * 展示条件：当前品牌配置了 showBrandDebugSwitch: true（当前为 amai / gxzs / juxflow），
 * 且处于开发/测试环境——?brand 覆盖仅在这两类构建生效（resolveBrand 同款判定），
 * 生产构建下点了也不切换，渲染出来只会是死按钮，故不展示。
 */

const DEBUG_BRANDS = [
  { key: 'gxzs', label: 'gxzs', domain: 'aifilm.gxzs.top' },
  { key: 'juxflow', label: 'juxflow', domain: 'juxflow.ame-film.com' },
];

const BrandDebugSwitch: React.FC = () => {
  const enabled =
    resolveBrand().showBrandDebugSwitch === true &&
    (import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'test');
  if (!enabled) return null;

  const params = new URLSearchParams(window.location.search);
  const activeBrand = params.get('brand');

  const switchTo = (key: string) => {
    const p = new URLSearchParams(window.location.search);
    if (p.get('brand') === key) {
      p.delete('brand');
    } else {
      p.set('brand', key);
    }
    const qs = p.toString();
    window.location.href =
      window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        alignItems: 'flex-end',
      }}
    >
      {DEBUG_BRANDS.map(brand => {
        const isActive = activeBrand === brand.key;
        return (
          <button
            key={brand.key}
            onClick={() => switchTo(brand.key)}
            title={`模拟 ${brand.domain}（${brand.label} 品牌）切换`}
            style={{
              height: 28,
              padding: '0 12px',
              borderRadius: 14,
              border: '1px solid rgba(255, 109, 73, 0.5)',
              background: 'rgba(18, 18, 18, 0.9)',
              color: isActive ? '#FF6D49' : 'rgba(255, 255, 255, 0.6)',
              fontSize: 12,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
            onMouseEnter={e => { e.currentTarget.style.color = '#FF6D49'; }}
            onMouseLeave={e => { e.currentTarget.style.color = isActive ? '#FF6D49' : 'rgba(255, 255, 255, 0.6)'; }}
          >
            {isActive ? `品牌: ${brand.label} ✓（点击恢复）` : `模拟 ${brand.label} 品牌`}
          </button>
        );
      })}
    </div>
  );
};

export default BrandDebugSwitch;
